import type { ReactNode } from "react";

export type IconBadgeTint =
  | "blue"
  | "green"
  | "red"
  | "orange"
  | "yellow"
  | "purple"
  | "teal"
  | "gray";

const TINT_BG: Record<IconBadgeTint, string> = {
  blue: "var(--system-blue)",
  green: "var(--system-green)",
  red: "var(--system-red)",
  orange: "var(--system-orange)",
  yellow: "var(--system-yellow)",
  purple: "var(--system-purple)",
  teal: "var(--system-teal)",
  gray: "var(--gray-1)",
};

export function IconBadge({
  children,
  tint = "blue",
  size = 28,
}: {
  children: ReactNode;
  tint?: IconBadgeTint;
  size?: number;
}) {
  return (
    <span
      aria-hidden
      className="grid place-items-center text-white shrink-0"
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.28),
        background: TINT_BG[tint],
      }}
    >
      {children}
    </span>
  );
}
